<template lang="pug">
    i-switch(
        :value="value"
        size="large"
        :true-value="formItem.trueValue"
        :false-value="formItem.falseValue"
        :disabled="disabled"
        @on-change="onChange")
        span(slot="open") {{ openText }}
        span(slot="close") {{ closeText }}
</template>
<script>
import { queryParamsFieldsCompletion } from "@/libs/rcmTableFieldsFunction";
export default {
    props: {
        formItem: {},
        formData: {},
        value: {},
        openText: { type: String, default: () => "On" },
        closeText: { type: String, default: () => "Off" },
    },
    data() {
        return {
            queryParamsFields: this.formItem.queryParamsFields || [],
        };
    },
    methods: {
        onChange(val) {
            this.$emit("input", val);
            this.formItem.watchField(val, this.formData);
        },
    },
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);
        var self = this;
        // 監聽需要注意的欄位
        this.queryParamsFields.forEach((field) => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function () {
                    return this.formData[fieldName];
                },
                async function (newVal, oldVal) {
                    // console.log(`${this.formItem.key}: ${fieldName} changed from ${oldVal} to ${newVal}`);
                    // 有條件的獲取新選項
                    if (queryIf(newVal)) {
                        let options = await self.formItem.remoteOptions(newVal);
                        this.$emit("input", options);
                    }
                },
                { deep: true }
            );
        });
    },
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Switch.vue